import React from 'react'
import styles from './CSS/Info.module.css'

function Info() {
  return (
    <div className={styles.info}>
      <p>Are your two fav actors in the same film?</p>
      <p>Find out below</p>
    </div>
  )
}

export default Info
